module.exports = __webpack_public_path__ + "static/icc-restroom-b743c112fe64a7cc1c7964bc661b3f26.jpeg";